module.exports = __webpack_public_path__ + "img/hathayoga32-800x1080.da2372a1.jpg";